import { Pause, Play, RotateCcw, RotateCw, X } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";
import { formatTime } from "@/lib/api";

export const GlobalPlayer = () => {
  const { current, playing, progress, duration, toggle, seek, skip, close } = usePlayer();
  if (!current) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] glass border-t border-sky-400/30 reveal" data-testid="global-player">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-3 flex items-center gap-4">
        <img src={current.image_url || current.show?.cover_url} alt="" className="h-12 w-12 rounded-lg object-cover hidden sm:block" />
        <div className="min-w-0 w-44 sm:w-60 shrink-0">
          <p className="text-sm font-semibold truncate" data-testid="global-player-title">{current.title}</p>
          <p className="text-xs text-slate-400 truncate">{current.show?.name || ""}</p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => skip(-15)} className="p-2 text-slate-300 hover:text-white" data-testid="global-player-back" aria-label="Back 15s"><RotateCcw size={18} /></button>
          <button onClick={toggle} className="h-11 w-11 rounded-full bg-sky-400 text-[#070F1E] flex items-center justify-center hover:scale-105 transition-transform" data-testid="global-player-toggle" aria-label={playing ? "Pause" : "Play"}>
            {playing ? <Pause size={20} fill="currentColor" /> : <Play size={20} fill="currentColor" className="ml-0.5" />}
          </button>
          <button onClick={() => skip(30)} className="p-2 text-slate-300 hover:text-white" data-testid="global-player-forward" aria-label="Forward 30s"><RotateCw size={18} /></button>
        </div>
        <div className="flex-1 flex items-center gap-3 min-w-0">
          <span className="font-mono text-xs text-slate-400 w-12 text-right" data-testid="global-player-progress">{formatTime(progress)}</span>
          <input type="range" min={0} max={duration || 0} step={1} value={progress} onChange={(e) => seek(Number(e.target.value))} className="flex-1 h-1.5 cursor-pointer" data-testid="global-player-seek" />
          <span className="font-mono text-xs text-slate-400 w-12">{formatTime(duration)}</span>
        </div>
        <button onClick={close} className="p-2 text-slate-400 hover:text-white" data-testid="global-player-close" aria-label="Close player"><X size={18} /></button>
      </div>
    </div>
  );
};
